<template>
  <div class="single__service-modal">

    <div @click="toggleSidebar" class="single__modal-btn-wraper single__modal-btn-wraper--2">
      <div class="single__modal-btn-left">
        <div class="single__modal-btn-icon" v-if="deliveryMapping === 4"
          v-html="$translate('Weberbuero::Template.serviceModalOpenBtnIconSpedition')"></div>
        <div class="single__modal-btn-icon" v-else-if="deliveryMapping === 16"
          v-html="$translate('Weberbuero::Template.serviceModalOpenBtnIconSpedition')"></div>
        <div class="single__modal-btn-icon" v-else-if="deliveryMapping === 6"
          v-html="$translate('Weberbuero::Template.serviceModalOpenBtnIconPaketversandDhl')"></div>
        <div class="single__modal-btn-icon" v-else-if="deliveryMapping === 20"
          v-html="$translate('Weberbuero::Template.serviceModalOpenBtnIconGLS')"></div>
        <div class="single__modal-btn-icon" v-else-if="deliveryMapping === 8"
          v-html="$translate('Weberbuero::Template.serviceModalOpenBtnIconAbholung')"></div>
        <div class="single__modal-btn-icon" v-else v-html="$translate('Weberbuero::Template.serviceModalOpenBtnIcon')">
        </div>

        <div class="single__modal-btn-text" v-if="deliveryMapping === 4">

          <div>
            {{ $translate("Weberbuero::Template.serviceModalOpenBtnLeftPaketversandDhl") }}
          </div>
          <div>
            <span class="single__stock"
              v-if="((currentVariation.variation.isMain && !currentVariation.filter.hasActiveChildren) || (!currentVariation.variation.isMain && !currentVariation.filter.hasActiveChildren)) && currentVariation.stock.net > 0 && currentVariation.variation.availability.id === 1"
              v-html="currentVariation.stock.net + ' ' + $translate('Weberbuero::Template.quickViewDeliveryStock')"></span>
            <span class="single__availability" v-if="currentVariation.variation.availability"
              v-html="$translate('Weberbuero::Template.quickViewDelivery1') + ' ' + currentVariation.variation.availability.names.name + (currentVariation.variation.availability.id === 1 ? 'n' : '') + ' ' + $translate('Weberbuero::Template.quickViewDelivery2')"></span>
          </div>
        </div>
        <div class="single__modal-btn-text" v-else-if="deliveryMapping === 16">
          <div>
            {{ $translate("Weberbuero::Template.serviceModalOpenBtnLeftSpedition") }}
          </div>

          <div>
            <span class="single__stock"
              v-if="((currentVariation.variation.isMain && !currentVariation.filter.hasActiveChildren) || (!currentVariation.variation.isMain && !currentVariation.filter.hasActiveChildren)) && currentVariation.stock.net > 0 && currentVariation.variation.availability.id === 1"
              v-html="currentVariation.stock.net + ' ' + $translate('Weberbuero::Template.quickViewDeliveryStock')"></span>
            <span class="single__availability" v-if="currentVariation.variation.availability"
              v-html="$translate('Weberbuero::Template.quickViewDelivery1') + ' ' + currentVariation.variation.availability.names.name + (currentVariation.variation.availability.id === 1 ? 'n' : '') + ' ' + $translate('Weberbuero::Template.quickViewDelivery2')"></span>
          </div>
        </div>
        <div class="single__modal-btn-text" v-else-if="deliveryMapping === 6">
          <div>
            {{ $translate("Weberbuero::Template.serviceModalOpenBtnLeftPaketversandDhl") }}
          </div>
          <div>
            <span class="single__stock"
              v-if="((currentVariation.variation.isMain && !currentVariation.filter.hasActiveChildren) || (!currentVariation.variation.isMain && !currentVariation.filter.hasActiveChildren)) && currentVariation.stock.net > 0 && currentVariation.variation.availability.id === 1"
              v-html="currentVariation.stock.net + ' ' + $translate('Weberbuero::Template.quickViewDeliveryStock')"></span>
            <span class="single__availability" v-if="currentVariation.variation.availability"
              v-html="$translate('Weberbuero::Template.quickViewDelivery1') + ' ' + currentVariation.variation.availability.names.name + (currentVariation.variation.availability.id === 1 ? 'n' : '') + ' ' + $translate('Weberbuero::Template.quickViewDelivery2')"></span>
          </div>
        </div>
        <div class="single__modal-btn-text" v-else-if="deliveryMapping === 20">
          <div>
            {{ $translate("Weberbuero::Template.serviceModalOpenBtnLeftGLS") }}
          </div>
          <div>
            <span class="single__stock"
              v-if="((currentVariation.variation.isMain && !currentVariation.filter.hasActiveChildren) || (!currentVariation.variation.isMain && !currentVariation.filter.hasActiveChildren)) && currentVariation.stock.net > 0 && currentVariation.variation.availability.id === 1"
              v-html="currentVariation.stock.net + ' ' + $translate('Weberbuero::Template.quickViewDeliveryStock')"></span>
            <span class="single__availability" v-if="currentVariation.variation.availability"
              v-html="$translate('Weberbuero::Template.quickViewDelivery1') + ' ' + currentVariation.variation.availability.names.name + (currentVariation.variation.availability.id === 1 ? 'n' : '') + ' ' + $translate('Weberbuero::Template.quickViewDelivery2')"></span>
          </div>
        </div>
        <div class="single__modal-btn-text" v-else-if="deliveryMapping === 8">
          <div>
            {{ $translate("Weberbuero::Template.serviceModalOpenBtnLeftAbholung") }}
          </div>
          <div>
            <span class="single__stock"
              v-if="((currentVariation.variation.isMain && !currentVariation.filter.hasActiveChildren) || (!currentVariation.variation.isMain && !currentVariation.filter.hasActiveChildren)) && currentVariation.stock.net > 0 && currentVariation.variation.availability.id === 1"
              v-html="currentVariation.stock.net + ' ' + $translate('Weberbuero::Template.quickViewDeliveryStock')"></span>
            <span class="single__availability" v-if="currentVariation.variation.availability"
              v-html="$translate('Weberbuero::Template.quickViewDelivery1') + ' ' + currentVariation.variation.availability.names.name + (currentVariation.variation.availability.id === 1 ? 'n' : '') + ' ' + $translate('Weberbuero::Template.quickViewDelivery2')"></span>
          </div>
        </div>
        <div class="single__modal-btn-text" v-else>
          <div>
            {{ $translate("Weberbuero::Template.serviceModalOpenBtnLeft") }}
          </div>
          <div>
            <span class="single__stock"
              v-if="((currentVariation.variation.isMain && !currentVariation.filter.hasActiveChildren) || (!currentVariation.variation.isMain && !currentVariation.filter.hasActiveChildren)) && currentVariation.stock.net > 0 && currentVariation.variation.availability.id === 1"
              v-html="currentVariation.stock.net + ' ' + $translate('Weberbuero::Template.quickViewDeliveryStock')"></span>
            <span class="single__availability" v-if="currentVariation.variation.availability"
              v-html="$translate('Weberbuero::Template.quickViewDelivery1') + ' ' + currentVariation.variation.availability.names.name + (currentVariation.variation.availability.id === 1 ? 'n' : '') + ' ' + $translate('Weberbuero::Template.quickViewDelivery2')"></span>
          </div>
        </div>
      </div>
      <div class="single__modal-link">
        {{ $translate("Weberbuero::Template.serviceModalOpenBtnRight") }}
        <i class="fa fa-angle-right"></i>
      </div>
    </div>


    <div class="service-sidebar__wrapper">
      <div @click.self="toggleSidebar" class="service-sidebar__backdrop"></div>
      <div class="service-sidebar__container">
        <div class="service-sidebar__content">
          <div class="service-sidebar__header">
            <span>{{ $translate("Weberbuero::Template.serviceSidebarHeadline") }}</span>
            <button @click="toggleSidebar" type="button" :aria-label="$translate('Ceres::Template.closeIcon')"
              class="close">
              <svg height="26" width="27">
                <use xlink:href="#svg_close" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg>
            </button>
          </div>

          <div class="dropdown__wrapper">
            <div class="dropdown__headline">{{ $translate("Weberbuero::Template.serviceSidebarCountryHeadline") }}</div>
            <div :class="{ 'open': openDropdown }" class="dropdown__header" @click="openDropdown = !openDropdown">
              <span v-if="activeLang != 'contact'">
                <i :class="'flag-icon flag-icon-' + activeLang"></i>

                <template v-if="activeLang === 'de'">Deutschland</template>
                <template v-else-if="activeLang === 'it'">Italien</template>
                <template v-else-if="activeLang === 'at'">Österreich</template>
                <template v-else>{{ activeLang }}</template>
              </span>

              <span v-else>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="fi_471664">
                    <g id="Vector">
                      <path
                        d="M8 2C4.6838 2 2 4.6835 2 8C2 11.3161 4.6835 14 8 14C11.3162 14 14 11.3165 14 8C14 4.6838 11.3165 2 8 2ZM8 13.1628C5.15323 13.1628 2.83721 10.8468 2.83721 8C2.83721 5.15321 5.15323 2.83721 8 2.83721C10.8468 2.83721 13.1628 5.15321 13.1628 8C13.1628 10.8468 10.8468 13.1628 8 13.1628Z"
                        fill="black" />
                      <path
                        d="M7.8224 9.59192C7.49069 9.59192 7.22217 9.86834 7.22217 10.2C7.22217 10.5239 7.48279 10.8082 7.8224 10.8082C8.16201 10.8082 8.43051 10.5239 8.43051 10.2C8.43051 9.86834 8.15409 9.59192 7.8224 9.59192Z"
                        fill="black" />
                      <path
                        d="M7.9255 4.98755C6.85928 4.98755 6.36963 5.6194 6.36963 6.04587C6.36963 6.35388 6.63025 6.49606 6.84349 6.49606C7.26998 6.49606 7.09624 5.8879 7.90181 5.8879C8.29668 5.8879 8.61262 6.06167 8.61262 6.42497C8.61262 6.85144 8.17033 7.09627 7.90971 7.3174C7.68065 7.51481 7.38056 7.83865 7.38056 8.51787C7.38056 8.92854 7.49114 9.04702 7.81493 9.04702C8.2019 9.04702 8.28089 8.87328 8.28089 8.72318C8.28089 8.31251 8.28878 8.07558 8.72318 7.73597C8.93641 7.57013 9.60771 7.03306 9.60771 6.29067C9.60771 5.54829 8.93641 4.98755 7.9255 4.98755Z"
                        fill="black" />
                      <path
                        d="M8 2C4.6838 2 2 4.6835 2 8C2 11.3161 4.6835 14 8 14C11.3162 14 14 11.3165 14 8C14 4.6838 11.3165 2 8 2ZM8 13.1628C5.15323 13.1628 2.83721 10.8468 2.83721 8C2.83721 5.15321 5.15323 2.83721 8 2.83721C10.8468 2.83721 13.1628 5.15321 13.1628 8C13.1628 10.8468 10.8468 13.1628 8 13.1628Z"
                        stroke="black" stroke-width="0.3" />
                      <path
                        d="M7.8224 9.59192C7.49069 9.59192 7.22217 9.86834 7.22217 10.2C7.22217 10.5239 7.48279 10.8082 7.8224 10.8082C8.16201 10.8082 8.43051 10.5239 8.43051 10.2C8.43051 9.86834 8.15409 9.59192 7.8224 9.59192Z"
                        stroke="black" stroke-width="0.3" />
                      <path
                        d="M7.9255 4.98755C6.85928 4.98755 6.36963 5.6194 6.36963 6.04587C6.36963 6.35388 6.63025 6.49606 6.84349 6.49606C7.26998 6.49606 7.09624 5.8879 7.90181 5.8879C8.29668 5.8879 8.61262 6.06167 8.61262 6.42497C8.61262 6.85144 8.17033 7.09627 7.90971 7.3174C7.68065 7.51481 7.38056 7.83865 7.38056 8.51787C7.38056 8.92854 7.49114 9.04702 7.81493 9.04702C8.2019 9.04702 8.28089 8.87328 8.28089 8.72318C8.28089 8.31251 8.28878 8.07558 8.72318 7.73597C8.93641 7.57013 9.60771 7.03306 9.60771 6.29067C9.60771 5.54829 8.93641 4.98755 7.9255 4.98755Z"
                        stroke="black" stroke-width="0.3" />
                    </g>
                  </g>
                </svg>

                {{ $translate("Weberbuero::Template.serviceSidebarCountryNotFound") }}
              </span>

              <svg class="ddown-arrow" width="12" height="8" viewBox="0 0 12 8" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path id="01 shape" fill-rule="evenodd" clip-rule="evenodd"
                  d="M11.0024 0.400391L6 5.54733L0.997554 0.400391L0 1.42676L6 7.60006L12 1.42676L11.0024 0.400391Z"
                  fill="#9B9B9B" />
              </svg>
            </div>
            <div class="dropdown__list" :class="{ 'open': openDropdown }">
              <div class="dropdown__list-item" v-for="(value, key, index) in shippingGroup"
                @click="activeLang = key; openDropdown = !openDropdown" :class="{ 'active': key === activeLang }">
                <i :class="'flag-icon flag-icon-' + key"></i>
                <template v-if="key === 'de'">Deutschland</template>
                <template v-else-if="key === 'it'">Italien</template>
                <template v-else-if="key === 'at'">Österreich</template>
                <template v-else-if="key === 'be'">Belgien</template>
                <template v-else-if="key === 'nl'">Niederlande</template>
                <template v-else-if="key === 'lux'">Luxemburg</template>
                <template v-else>{{ key }}</template>
              </div>
              <div class="dropdown__list-item" @click="activeLang = 'contact'; openDropdown = !openDropdown"
                :class="{ 'active': 'contact' === activeLang }">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="fi_471664">
                    <g id="Vector">
                      <path
                        d="M8 2C4.6838 2 2 4.6835 2 8C2 11.3161 4.6835 14 8 14C11.3162 14 14 11.3165 14 8C14 4.6838 11.3165 2 8 2ZM8 13.1628C5.15323 13.1628 2.83721 10.8468 2.83721 8C2.83721 5.15321 5.15323 2.83721 8 2.83721C10.8468 2.83721 13.1628 5.15321 13.1628 8C13.1628 10.8468 10.8468 13.1628 8 13.1628Z"
                        fill="black" />
                      <path
                        d="M7.8224 9.59192C7.49069 9.59192 7.22217 9.86834 7.22217 10.2C7.22217 10.5239 7.48279 10.8082 7.8224 10.8082C8.16201 10.8082 8.43051 10.5239 8.43051 10.2C8.43051 9.86834 8.15409 9.59192 7.8224 9.59192Z"
                        fill="black" />
                      <path
                        d="M7.9255 4.98755C6.85928 4.98755 6.36963 5.6194 6.36963 6.04587C6.36963 6.35388 6.63025 6.49606 6.84349 6.49606C7.26998 6.49606 7.09624 5.8879 7.90181 5.8879C8.29668 5.8879 8.61262 6.06167 8.61262 6.42497C8.61262 6.85144 8.17033 7.09627 7.90971 7.3174C7.68065 7.51481 7.38056 7.83865 7.38056 8.51787C7.38056 8.92854 7.49114 9.04702 7.81493 9.04702C8.2019 9.04702 8.28089 8.87328 8.28089 8.72318C8.28089 8.31251 8.28878 8.07558 8.72318 7.73597C8.93641 7.57013 9.60771 7.03306 9.60771 6.29067C9.60771 5.54829 8.93641 4.98755 7.9255 4.98755Z"
                        fill="black" />
                      <path
                        d="M8 2C4.6838 2 2 4.6835 2 8C2 11.3161 4.6835 14 8 14C11.3162 14 14 11.3165 14 8C14 4.6838 11.3165 2 8 2ZM8 13.1628C5.15323 13.1628 2.83721 10.8468 2.83721 8C2.83721 5.15321 5.15323 2.83721 8 2.83721C10.8468 2.83721 13.1628 5.15321 13.1628 8C13.1628 10.8468 10.8468 13.1628 8 13.1628Z"
                        stroke="black" stroke-width="0.3" />
                      <path
                        d="M7.8224 9.59192C7.49069 9.59192 7.22217 9.86834 7.22217 10.2C7.22217 10.5239 7.48279 10.8082 7.8224 10.8082C8.16201 10.8082 8.43051 10.5239 8.43051 10.2C8.43051 9.86834 8.15409 9.59192 7.8224 9.59192Z"
                        stroke="black" stroke-width="0.3" />
                      <path
                        d="M7.9255 4.98755C6.85928 4.98755 6.36963 5.6194 6.36963 6.04587C6.36963 6.35388 6.63025 6.49606 6.84349 6.49606C7.26998 6.49606 7.09624 5.8879 7.90181 5.8879C8.29668 5.8879 8.61262 6.06167 8.61262 6.42497C8.61262 6.85144 8.17033 7.09627 7.90971 7.3174C7.68065 7.51481 7.38056 7.83865 7.38056 8.51787C7.38056 8.92854 7.49114 9.04702 7.81493 9.04702C8.2019 9.04702 8.28089 8.87328 8.28089 8.72318C8.28089 8.31251 8.28878 8.07558 8.72318 7.73597C8.93641 7.57013 9.60771 7.03306 9.60771 6.29067C9.60771 5.54829 8.93641 4.98755 7.9255 4.98755Z"
                        stroke="black" stroke-width="0.3" />
                    </g>
                  </g>
                </svg>

                {{ $translate("Weberbuero::Template.serviceSidebarCountryNotFound") }}
              </div>
            </div>
          </div>

          <div class="shipping-profiles" v-if="activeLang != 'contact'">
            <template v-if="shippingGroup">
              <template v-for="(group, key, index) in shippingGroup[activeLang]">
                <div class="shipping-profile__wrapper" v-if="key >= shippingIndex">
                  <div class="shipping-profile__img" v-if="key === (shippingGroup[activeLang].length - 1)">
                    <div v-if="deliveryMapping === 4"
                      v-html="$translate('Weberbuero::Template.serviceModalOpenBtnIconSpedition')"></div>
                    <div v-else-if="deliveryMapping === 16"
                      v-html="$translate('Weberbuero::Template.serviceModalOpenBtnIconSpedition')"></div>
                    <div v-else-if="deliveryMapping === 6"
                      v-html="$translate('Weberbuero::Template.serviceModalOpenBtnIconPaketversandDhl')"></div>
                    <div v-else-if="deliveryMapping === 20"
                      v-html="$translate('Weberbuero::Template.serviceModalOpenBtnIconGLS')"></div>
                    <div v-else-if="deliveryMapping === 8"
                      v-html="$translate('Weberbuero::Template.serviceModalOpenBtnIconAbholung')"></div>
                    <div v-else v-html="$translate('Weberbuero::Template.serviceModalOpenBtnIcon')"></div>
                  </div>
                  <img v-else class="shipping-profile__img" :src="group.icon" :alt="group.name">
                  <div class="shipping-profile__content">

                    <div class="shipping-profile__name" v-if="key === (shippingGroup[activeLang].length - 1)">
                      <template v-if="deliveryMapping === 4">
                        {{ $translate("Weberbuero::Template.serviceModalOpenBtnLeftPaketversandDhl") }}
                      </template>
                      <template v-else-if="deliveryMapping === 16">
                        {{ $translate("Weberbuero::Template.serviceModalOpenBtnLeftSpedition") }}
                      </template>
                      <template v-else-if="deliveryMapping === 6">
                        {{ $translate("Weberbuero::Template.serviceModalOpenBtnLeftPaketversandDhl") }}
                      </template>
                      <template v-else-if="deliveryMapping === 20">
                        {{ $translate("Weberbuero::Template.serviceModalOpenBtnLeftGLS") }}
                      </template>
                      <template v-else-if="deliveryMapping === 8">
                        {{ $translate("Weberbuero::Template.serviceModalOpenBtnLeftAbholung") }}
                      </template>
                      <template v-else>
                        {{ $translate("Weberbuero::Template.serviceModalOpenBtnLeft") }}
                      </template>
                    </div>

                    <div v-else class="shipping-profile__name">
                      {{ group.name }}
                    </div>



                    <div class="shipping-profile__price">
                      <span>{{ group.article1.toLocaleString('de-DE', { style: 'currency', currency: "EUR" }) }}</span>
                      <span> - Jeder weitere Artikel: {{ group.article2.toLocaleString('de-DE', {
                        style: 'currency',
                        currency: "EUR"
                      })
                        }}</span>

                    </div>
                  </div>
                </div>
              </template>
            </template>
          </div>
          <div v-else class="contact-box__wrapper">
            <div class="contact-box__headline">{{ $translate("Weberbuero::Template.serviceSidebarContactHeadline") }}
            </div>
            <div class="contact-box__text">{{ $translate("Weberbuero::Template.serviceSidebarContactText") }}</div>
            <a class="contact-box__btn" :href="$translate('Weberbuero::Template.serviceSidebarContactBtnUrl')">{{
              $translate("Weberbuero::Template.serviceSidebarContactBtn") }}</a>
          </div>

          <div class="sidebar-faq__wrapper">
            <div class="sidebar-faq__headline">{{ $translate("Weberbuero::Template.serviceSidebarFaqHeadline") }}</div>
            <div class="sidebar-faq__item">
              <div class="sidebar-faq__item-title" :class="{ 'open': faq1Open }" @click="faq1Open = !faq1Open">
                <span>{{ $translate("Weberbuero::Template.serviceSidebarFaqItem1Headline") }}</span>
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path id="01 shape" fill-rule="evenodd" clip-rule="evenodd"
                    d="M11.0024 0.400391L6 5.54733L0.997554 0.400391L0 1.42676L6 7.60006L12 1.42676L11.0024 0.400391Z"
                    fill="#9B9B9B" />
                </svg>
              </div>
              <div class="sidebar-faq__item-text" :style="faq1Open ? 'height:' + faq1TxtHeight : 'height: 0'">
                <div class="sidebar-faq__item-text-inner" ref="faq1Txt"
                  v-html="$translate('Weberbuero::Template.serviceSidebarFaqItem1Text')">
                </div>
              </div>
            </div>
            <div class="sidebar-faq__item">
              <div class="sidebar-faq__item-title" :class="{ 'open': faq2Open }" @click="faq2Open = !faq2Open">
                <span>{{ $translate("Weberbuero::Template.serviceSidebarFaqItem2Headline") }}</span>
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path id="01 shape" fill-rule="evenodd" clip-rule="evenodd"
                    d="M11.0024 0.400391L6 5.54733L0.997554 0.400391L0 1.42676L6 7.60006L12 1.42676L11.0024 0.400391Z"
                    fill="#9B9B9B" />
                </svg>
              </div>
              <div class="sidebar-faq__item-text" :style="faq2Open ? 'height:' + faq2TxtHeight : 'height: 0'">
                <div class="sidebar-faq__item-text-inner" ref="faq2Txt"
                  v-html="$translate('Weberbuero::Template.serviceSidebarFaqItem2Text')">
                </div>
              </div>
            </div>
            <div class="sidebar-faq__item">
              <div class="sidebar-faq__item-title" :class="{ 'open': faq3Open }" @click="faq3Open = !faq3Open">
                <span>{{ $translate("Weberbuero::Template.serviceSidebarFaqItem3Headline") }}</span>
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path id="01 shape" fill-rule="evenodd" clip-rule="evenodd"
                    d="M11.0024 0.400391L6 5.54733L0.997554 0.400391L0 1.42676L6 7.60006L12 1.42676L11.0024 0.400391Z"
                    fill="#9B9B9B" />
                </svg>
              </div>
              <div class="sidebar-faq__item-text" :style="faq3Open ? 'height:' + faq3TxtHeight : 'height: 0'">
                <div class="sidebar-faq__item-text-inner" ref="faq3Txt"
                  v-html="$translate('Weberbuero::Template.serviceSidebarFaqItem3Text')">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
import shippingCosts from "../../data/shippingCosts"

export default {
  data() {
    return {
      modalShow: false,
      openDropdown: false,
      activeLang: "de",
      faq1Open: false,
      faq2Open: false,
      faq3Open: false,

    }
  },

  computed: {
    faq1TxtHeight() {
      return this.$refs.faq1Txt.clientHeight + "px"
    },
    faq2TxtHeight() {
      return this.$refs.faq2Txt.clientHeight + "px"
    },
    faq3TxtHeight() {
      return this.$refs.faq3Txt.clientHeight + "px"
    },

    highestCosts() {
      let costs = 0;
      costs = this.$store.getters.currentItemVariation.variation.defaultShippingCosts;
      return costs
    },

    shippingCostsJson() {
      return App.shippingCosts
    },


    shippingGroup() {
      for (let key in this.shippingCostsJson) {
        for (let key2 in this.shippingCostsJson[key].de) {
          if (this.shippingCostsJson[key].de[key2].article1 == this.highestCosts) {
            return this.shippingCostsJson[key]
          }
        }
      }
    },

    shippingIndex() {
      if (this.shippingGroup && this.shippingGroup.de) {
        return this.shippingGroup.de.findIndex(item => item.article1 === this.highestCosts)
      }
    },



    showNetPrices() {
      return App.initialData.showNetPrices;
    },

    deliveryMapping() {
      let deliveryText = "";
      let deliveryTextMontage = "";

      for (let key in this.currentVariation.properties) {
        if (this.currentVariation.properties.hasOwnProperty(key)) {
          if (this.currentVariation.properties[key].propertyId === 12) {
            deliveryText = this.currentVariation.properties[key].texts.value;
          }
          if (this.currentVariation.properties[key].propertyId === 11) {
            deliveryTextMontage = this.currentVariation.properties[key].texts.value;
          }
        }
      }

      let shippingId = 0;

      if (deliveryText.indexOf("Speditionsversand") > -1 && deliveryText.indexOf("Paketversand") > -1) {
        shippingId = 4; // serviceModalOpenBtnLeftPaketversandDhl
      } else if (deliveryText.indexOf("Speditionsversand") > -1) {
        shippingId = 16;
      } else if (deliveryText.indexOf("Paketversand") > -1) {
        shippingId = 6;
      } else if (deliveryText.indexOf("DHL") > -1) {
        shippingId = 6;
      } else if (deliveryText.indexOf("GEL Express") > -1) {
        shippingId = 20;
      } else if (deliveryText.indexOf("abholung") > -1) {
        shippingId = 8;
      } else {
        shippingId = 11;
      }

      if (deliveryTextMontage.length > 0 && deliveryText === "" && deliveryTextMontage.indexOf("Montage") > -1) {
        shippingId = 11; // oder 12
      }

      return shippingId;

    },

    formattedShippingPrice() {
      const formatter = new MonetaryFormatter();
      const shippingCosts = this.$store.getters.currentItemVariation.variation.defaultShippingCosts;
      if (shippingCosts > 0) {
        return formatter.format(parseFloat(shippingCosts), App.activeCurrency);
      }
      return formatter.format(parseFloat(0.0), App.activeCurrency);
    },

    combiShippingPrice() {
      const formatter = new MonetaryFormatter();
      const extraShipping = this.$store.getters.currentItemVariation.variation.extraShippingCharge2;
      if (extraShipping > 0) {
        return formatter.format(parseFloat(extraShipping), App.activeCurrency);
      }

      return formatter.format(parseFloat(0.0), App.activeCurrency);
    },

    combiShippingText() {
      const extraShipping = this.$store.getters.currentItemVariation.variation.extraShippingCharge2;
      if (extraShipping > 0) {
        return TranslationService.translate("Weberbuero::Template.singleShippingSecondItem", {
          "value": extraShipping.toLocaleString('de-DE', {
            style: 'currency',
            currency: "EUR"
          })
        });
      }
      return TranslationService.translate("Weberbuero::Template.singleShippingSecondItemFree");
    },

    ShippingText() {
      if (this.$store.getters.currentItemVariation.variation.defaultShippingCosts > 0) {
        return TranslationService.translate("Weberbuero::Template.singleItemShippingCostsWithPrice", { "value": this.formattedShippingPrice });
      } else {
        return TranslationService.translate("Weberbuero::Template.singleItemShippingCostsPriceIncluded");
      }

    },


    kw() {
      let mapping = {
        1: App.weberConfig.kwavail1,
        2: App.weberConfig.kwavail2,
        3: App.weberConfig.kwavail3,
        4: App.weberConfig.kwavail4,
        5: App.weberConfig.kwavail5,
        6: App.weberConfig.kwavail6,
        7: App.weberConfig.kwavail7,
        8: App.weberConfig.kwavail8,
        9: App.weberConfig.kwavail9,
        10: App.weberConfig.kwavail10
      };

      let days = parseInt(mapping[this.currentVariation.variation.availability.id]);
      let currentDate = new Date();
      let newDate = new Date();
      newDate.setDate(currentDate.getDate() + days);

      let cwDate = new Date(newDate.valueOf());
      let dayn = (newDate.getDay() + 6) % 7;
      cwDate.setDate(cwDate.getDate() - dayn + 3);
      let firstThursday = cwDate.valueOf();
      cwDate.setMonth(0, 1);
      if (cwDate.getDay() !== 4) {
        cwDate.setMonth(0, 1 + ((4 - cwDate.getDay()) + 7) % 7);
      }

      let cw = 1 + Math.ceil((firstThursday - cwDate) / 604800000);

      let day = newDate.getDay();
      if (day === 0) {
        day = 7;
      }
      newDate.setDate(newDate.getDate() - (day - 1));

      let actualMonth = newDate.getMonth() + 1;
      let actualDay = newDate.getDate();
      actualMonth = actualMonth + "";
      actualDay = actualDay + "";
      if (actualMonth.length === 1) {
        actualMonth = "0" + actualMonth;
      }
      if (actualDay.length === 1) {
        actualDay = "0" + actualDay;
      }

      let cwDateFormatted = actualDay + "." + actualMonth + ".";

      return [cw, cwDateFormatted];
    },

    currentVariation() {
      return this.$store.getters.currentItemVariation;
    }
  },

  methods: {
    toggleSidebar() {
      document.body.classList.toggle("service-sidebar--open");
    },
  }
};
</script>
